import { createStore, getDefaultMiddleware, applyMiddleware } from '@reduxjs/toolkit';
import { createWrapper, HYDRATE } from 'next-redux-wrapper';
import { sentryRedux } from 'root/utils/raven';
import rootReducer from './rootReducer';

const bindMiddleware = (middleware) => applyMiddleware(...middleware);

const combinedReducer = rootReducer;

const reducer = (state, action) => {
  if (action.type === HYDRATE) {
    return {
      ...state, // use previous state
      ...action.payload, // apply delta from hydration
      notifications: state.notifications
    };
  }
  return combinedReducer(state, action);
};

const initStore = () => createStore(reducer, bindMiddleware([
  sentryRedux, ...getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: []
    }
  })
]));

export const wrapper = createWrapper(initStore);
